import { createStore } from 'redux';
import { getFilteredEvents } from '../utils/FilterEvents';

const defaultState = {
  //GLOBAL
  appWidth:window.innerWidth,
  appHeight:window.innerHeight,
  embed:null,
  hideHeader:false,
  appView:'About',
  sideNavOpen:window.innerWidth > 560,
  //LOGGED IN USER STUFF
  loggedInUser:null,
  loggedInUserAccount:null,
  loggedInUserAvatarUrl:null,
  loggedInUserFriends:null,
  //VIEWING USER STUFF
  viewingUserAccount:null,
  viewingUserAvatarUrl:null,
  viewingUserName:null,
  viewingUserCategories:null,
  viewingUserFriends:null,
  viewingUserTrips:null,
  viewingUserTags:null,
  viewingUserEvents:null,
  //FILTER STUFF
  selectedCategoryIds:[],
  selectedFriendIds:[],
  selectedTagIds:[],
  selectedTripIds:[],
  selectedStartDate:null,
  selectedEndDate:null,
  filteredEvents:null,
  //MAP STUFF
  map: null,
  mapsLibrary: null,
  markerLibrary: null,
  placesLibrary: null,
  coreLibrary: null,
  placesService: null,
  autocompleteService: null,
  selectedEvent:null,
  eventKey:0,
  //TIMELINE STUFF
  selectedGroup:null,
  //SEARCH STUFF
  searchInput: '',
  //DIALOG STUFF
  dialogOpen:'',
  dialogData:null,
  //MAP RESET FAB
  showResetView:false,
  mapResetTrigger:0,
};

const Reducer = (state = defaultState, action) => {
  state = Object.assign({}, state)
  switch (action.type) {
    case "SET_APP_DIMENSIONS":
      state.appWidth = action.data.appWidth;
      state.appHeight = action.data.appHeight;
      return state;
    case "SET_APP_VIEW":
      state.appView = action.data.appView;
      return state;
    case "SET_SIDE_NAV_OPEN":
      state.sideNavOpen = action.data.sideNavOpen;
      return state;
    case "SET_EMBED":
      state.embed = action.data.embed;
      return state;
    case "SET_HIDE_HEADER":
      state.hideHeader = action.data.hideHeader;
      return state;
    case "SET_LOGGED_IN_USER":
      state.loggedInUser = action.data.loggedInUser;
      state.loggedInUserAccount = null;
      state.loggedInUserAvatarUrl = '';
      return state;
    case "SET_LOGGED_IN_USER_ACCOUNT":
      state.loggedInUserAccount = action.data.loggedInUserAccount;
      if(state.loggedInUserAccount.avatarUrl){
        state.loggedInUserAvatarUrl = action.data.loggedInUserAccount.avatarUrl + '&' + (new Date()).getTime();
      }
      if(state.viewingUserAccount && state.viewingUserAccount.id == state.loggedInUserAccount.id){
        state.viewingUserName = state.loggedInUserAccount.displayName;
        state.viewingUserAvatarUrl = state.viewingUserAccount.avatarUrl + '&' + (new Date()).getTime();
      }
      return state;
    case "SET_VIEWING_USER_ACCOUNT":
      state.viewingUserAccount = action.data.viewingUserAccount;
      state.viewingUserName = action.data.viewingUserAccount.displayName;
      state.viewingUserAvatarUrl = action.data.viewingUserAccount.avatarUrl;
      state.selectedEvent = null;
      return state;
    case "SET_VIEWING_USER_CATEGORIES":
      state.viewingUserCategories = action.data.viewingUserCategories;
      return state;
    case "SET_VIEWING_USER_FRIENDS":
      state.viewingUserFriends = action.data.viewingUserFriends;
      return state;
    case "SET_VIEWING_USER_TRIPS":
      state.viewingUserTrips = action.data.viewingUserTrips;
      return state;
    case "SET_VIEWING_USER_TAGS":
      state.viewingUserTags = action.data.viewingUserTags;
      return state;
    case "SET_VIEWING_USER_EVENTS":
      state.viewingUserEvents = action.data.viewingUserEvents;
      state.filteredEvents = getFilteredEvents(state.viewingUserEvents, state.selectedCategoryIds, state.selectedFriendIds, state.selectedTagIds, state.selectedTripIds,state.selectedStartDate, state.selectedEndDate);
      state.eventKey+=1;
      return state;
    case "SET_FILTERS":
      state.selectedCategoryIds = action.data.selectedCategoryIds;
      state.selectedFriendIds = action.data.selectedFriendIds;
      state.selectedTagIds = action.data.selectedTagIds;
      state.selectedTripIds = action.data.selectedTripIds;
      state.selectedStartDate = action.data.selectedStartDate;
      state.selectedEndDate = action.data.selectedEndDate;
      state.filteredEvents = getFilteredEvents(state.viewingUserEvents, state.selectedCategoryIds, state.selectedFriendIds, state.selectedTagIds, state.selectedTripIds,state.selectedStartDate, state.selectedEndDate);
      state.eventKey+=1;
      return state;
    case "SET_MAP":
        state.map = action.data.map;
        state.mapsLibrary = action.data.mapsLibrary;
        state.markerLibrary = action.data.markerLibrary;
        state.placesLibrary = action.data.placesLibrary;
        state.coreLibrary = action.data.coreLibrary;
        state.placesService = new action.data.placesLibrary.PlacesService(action.data.map);
        state.autocompleteService = new action.data.placesLibrary.AutocompleteService();
        return state;
    case "SET_SELECTED_EVENT":
      state.selectedEvent = action.data.event;
      return state;
    case "SET_SELECTED_GROUP":
      state.selectedGroup = action.data.group;
      return state;
    case "SET_SEARCH_INPUT":
      state.searchInput = action.data.searchInput;
      return state;
    case "SET_DIALOG_OPEN":
      state.dialogOpen = action.data.dialogOpen;
      state.dialogData = action.data.dialogData;
      return state;
    case "SET_SHOW_RESET_VIEW":
      state.showResetView = action.data.showResetView;
      return state;
    case "TRIGGER_MAP_RESET":
      state.mapResetTrigger = state.mapResetTrigger + 1;
      return state;
    default:
      return state
  }
};

let Store = createStore(Reducer)

export default Store;
